import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import api from "../api/index";
const axios = require("axios");

const initialState = {
  loading: false,
  error: false,
  data: [],
};

const pricelistsSlice = createSlice({
  name: "pricelists",
  initialState,
  reducers: {},
  extraReducers(builder) {
    builder
      .addCase(getPricelistByUserCode.pending, (state) => {
        state.loading = true;
      })
      .addCase(getPricelistByUserCode.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(getPricelistByUserCode.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const getPricelistByUserCode = createAsyncThunk(
  "pricelistsSlice/getPricelistByUserCode",
  async (userCode) => {
    try {
      const { url, method, headers } = api.getPricelistByUserCode(userCode);
      const referents = await axios({
        url,
        method,
        headers,
      });
      return referents.data;
    } catch (error) {
      return error.message;
    }
  }
);

export const { actions } = pricelistsSlice;
export default pricelistsSlice.reducer;
